import { transformWithSpec } from "../../../utils/response.js";
function personalInfo(builder) {
  return {
    updatePersonalInfo: builder.mutation({
      invalidatesTags: ["personal-info"],
      query: (data) => ({
        url: `/member/personal-info`,
        method: "POST",
        body: data
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  personalInfo as default
};
